import { MaybeRefOrGetter, onUnmounted, Ref, toValue, watch } from 'vue'

import { Event } from '@collector/sportsapi-client-legacy'

const KEEP_ALIVE_INTERVAL_MS = 30_000

export function useKeepAlive(
  event: Ref<Event>,
  keepAlive: (eventId: number) => Promise<void>,
  currentRequestUrl: MaybeRefOrGetter<string | undefined>,
  enabled: MaybeRefOrGetter<boolean> = () => true,
): void {
  let timeoutId: ReturnType<typeof setTimeout> | null = null

  // methods
  function startTimer(): void {
    clearTimer()
    timeoutId = setTimeout(async () => {
      try {
        if (toValue(enabled)) await keepAlive(event.value.id)
      } finally {
        startTimer()
      }
    }, KEEP_ALIVE_INTERVAL_MS)
  }

  function clearTimer(): void {
    if (timeoutId !== null) {
      clearTimeout(timeoutId)
      timeoutId = null
    }
  }

  function init(): void {
    switch (event.value.relation_status) {
      case 'not_started':
      case 'finished':
        clearTimer()
        break
      case '5_min_left':
      case '30_min_left':
      case 'in_progress':
        startTimer()
        break
    }
  }

  // init
  watch(
    () => event.value.relation_status,
    () => init(),
    { immediate: true },
  )

  watch(
    () => toValue(currentRequestUrl),
    () => {
      if (
        !new URL(toValue(currentRequestUrl)!).pathname.endsWith('/keep-alive')
      ) {
        init()
      }
    },
  )

  onUnmounted(() => {
    clearTimer()
  })
}
